/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log("Expanse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co");
}

(function () {
  "use strict";

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }

  theme.smoothScroll = function() {
    document.body.addEventListener('click', function(event) {
      console.log('ready');
      var target = event.target.closest('[href^="#"], [data-href]');
      if (!target) return;

      var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');

      if (selector === '#' || selector === '#main') {
        return;
      }
      if (selector === '#looxicons-rating-icon') {
        selector = '#looxReviews';
      }
      var header = document.querySelector('[data-section-type="header"]')
      
      if(!header) {
        console.error('Header element not found');
        return;
      }
      var headerHeight = header.offsetHeight;

      if(window.screen.width <= 640) {
        headerHeight += 59;
      }

      var element = null;
      try {
        element = document.querySelector(selector);
      } catch (exception) {
        // We may have an invalid selector, so if we catch it we just return
        return;
      }

      if(element != null) {
        var offset = parseInt(target.getAttribute('data-offset') || 0),
        toTop = 0;
        toTop -= headerHeight;
        
        while (element.offsetParent && element.offsetParent.tagName !== 'BODY') {
          toTop += element.offsetTop;
          element = element.offsetParent;
        }

        if (element.offsetParent) {
          toTop += element.offsetTop;
        }

        console.log(toTop);

        //toTop -= 144;
        window.scrollTo({
          behavior: 'smooth',
          top: toTop - offset
        });
      }
      event.preventDefault();
    });
  }

  theme.copyCouponButtons = function() {
    const couponButtons = document.querySelectorAll('.coupon-copy-button');
    
    couponButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        
        let textToCopy = '';
        const couponCode = button.querySelector('.coupon-code');
        
        if(couponCode) {
          textToCopy = couponCode.innerText;
        }
        
        if (textToCopy) {
          copyToClipboard(textToCopy, button);
        }
      });
    });
      
  
    function copyToClipboard(text, button) {
      navigator.clipboard.writeText(text).then(() => {
        const copyButtonText = button.innerHTML;
        button.innerHTML = 'copied to clipboard';
        
        setTimeout(() => {
          button.innerHTML = copyButtonText;
        }, 1000);
      }).catch(err => {
        console.error('Error copying text: ', err);
      });
    }
  }

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  theme.quizEmbedPopups = function() {
    document.addEventListener("page:loaded", function(){
      let body = document.getElementsByTagName('body')[0];
      let close_btns = document.getElementsByClassName('hide-quiz-popup');
      let popups = document.querySelectorAll('.quiz-popup');

      if(popups.length == 0) {
        return;
      }
      Array.from(popups).forEach(function(popup){
        body.appendChild(popup);
      })

      Array.from(close_btns).forEach(function(close_btn){
        close_btn.addEventListener('click', function(e){
          Array.from(popups).forEach(function(popup){
            if(popup.classList.contains('active')) {
              popup.classList.remove('active');
            }
          });
        });
      });
      
  
      let popup_btns = document.getElementsByClassName('show-quiz-popup');

      Array.from(popup_btns).forEach(function(popup_btn){
        popup_btn.addEventListener('click', function(e){
          e.preventDefault();
          let block_id = e.currentTarget.dataset.block;
          let popup = document.querySelector('.quiz-popup[data-block="' + block_id + '"]');
          
          if(!popup.classList.contains('active')) {
            popup.classList.add('active');
          }
        });
      });
      
  
      document.addEventListener('click', function(e){
        if(!e.target.closest('.popup_embed') && !e.target.closest('.show-quiz-popup')) {
          let popup_active = document.querySelector('.quiz-popup.active');
          if(popup_active != null) {
            popup_active.classList.remove('active');
          }
        }
      })
    });
  }
  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    theme.smoothScroll();
    theme.copyCouponButtons();
    theme.quizEmbedPopups();
    document.dispatchEvent(new CustomEvent("page:loaded"));
    
  });
})();
